import { FilterComponent } from '~/components/ApplicationReports/components/FilterComponent.tsx';
import { applicationStatus, clientApplicationType } from '~/constants/directoryList.ts';
import {
  containsOperator,
  formatDate,
  selectOperator,
} from '~/components/ApplicationReports/utils/utils.tsx';
import {
  SelectFilterInputProps,
  TApplicationReportContent,
} from '~/components/ApplicationReports/types.ts';
import { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';

export const statusSelect = selectOperator('selectStatus', (props: SelectFilterInputProps) => (
  <FilterComponent {...props} options={applicationStatus} labelId="status-filter-label" />
));

export const applicationTypeSelect = selectOperator(
  'selectApplicationType',
  (props: SelectFilterInputProps) => (
    <FilterComponent
      {...props}
      options={clientApplicationType}
      labelId="application-type-filter-label"
    />
  )
);

export const identificationSelect = selectOperator(
  'selectIdentification',
  (props: SelectFilterInputProps) => {
    const rows: (TApplicationReportContent | null)[] = Array.from(
      props.apiRef!.current.getAllRowIds()
    ).map((id) => props.apiRef!.current.getRow(id));

    const options: TAutocompleteOption[] = Array.from(
      new Set(rows.map((row) => row?.identificationNumber))
    )
      .filter((val): val is string => Boolean(val))
      .map((val) => ({ value: val, label: val }));

    return <FilterComponent {...props} options={options} labelId="identification-filter-label" />;
  }
);

export const identificationSearch = containsOperator('containsIdentification');

export const lastUpdatedAtSelect = selectOperator(
  'selectLastUpdatedAt',
  (props: SelectFilterInputProps) => {
    const rows: (TApplicationReportContent | null)[] = Array.from(
      props.apiRef!.current.getAllRowIds()
    ).map((id) => props.apiRef!.current.getRow(id));

    const uniqueOptions: Record<string, { value: string; label: string }> = {};

    rows.forEach((row) => {
      const originalDate = row?.lastUpdatedAt as string;
      if (originalDate) {
        const dateKey = new Date(originalDate).toISOString().split('T')[0] || -1;
        if (!uniqueOptions[dateKey]) {
          uniqueOptions[dateKey] = {
            value: originalDate as string,
            label: formatDate(originalDate) || '',
          };
        }
      }
    });

    return (
      <FilterComponent
        {...props}
        options={Object.values(uniqueOptions)}
        labelId="last-updated-at-filter-label"
      />
    );
  }
);

export const createdAtSelect = selectOperator(
  'selectCreatedAt',
  (props: SelectFilterInputProps) => {
    const rows: (TApplicationReportContent | null)[] = Array.from(
      props.apiRef!.current.getAllRowIds()
    ).map((id) => props.apiRef!.current.getRow(id));

    const uniqueOptions: Record<string, { value: string; label: string }> = {};

    rows.forEach((row) => {
      const originalDate = row?.createdAt as string;
      if (originalDate) {
        const dateKey = new Date(originalDate).toISOString().split('T')[0] || -1;
        if (!uniqueOptions[dateKey]) {
          uniqueOptions[dateKey] = {
            value: originalDate as string,
            label: formatDate(originalDate) || '',
          };
        }
      }
    });

    return (
      <FilterComponent
        {...props}
        options={Object.values(uniqueOptions)}
        labelId="created-at-filter-label"
      />
    );
  }
);
